import Vue from 'vue'
import Vuex from 'vuex'
import auth from '@/store/modules/Auth'
import user from '@/store/modules/User'
import typetalk from '@/store/modules/Typetalk'
import Announcement from '@/store/modules/Announcement'
import Achievement from '@/store/modules/Achievement'
import Portofolio from '@/store/modules/Portofolio'
import career from '@/store/modules/Career'
import profile from '@/store/modules/Profile'

import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const getDefaultState = () => {
  return {}
}

export default new Vuex.Store({
  state: getDefaultState(),
  getters: {},
  mutations: {
    resetState(state) {
      state = Object.assign(state, getDefaultState())
    }
  },
  actions: {},
  modules: {
    auth,
    user,
    typetalk,
    Announcement,
    Achievement,
    Portofolio,
    career,
    profile
  },
  plugins: [createPersistedState({ paths: ['auth', 'user'], storage: window.localStorage })]
})
